import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-h6" }, "Szállás igények", -1)
const _hoisted_2 = { style: {"font-family":"monospace"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_AdminAccommodationInquiryFormDialog = _resolveComponent("AdminAccommodationInquiryFormDialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    text: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                label: "Search",
                "prepend-inner-icon": "mdi-magnify",
                variant: "outlined",
                "hide-details": "",
                "single-line": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: _ctx.statusFilter,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.statusFilter) = $event)),
                items: _ctx.statusOptions,
                label: "Státusz",
                variant: "outlined",
                "hide-details": "",
                clearable: ""
              }, null, 8, ["modelValue", "items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_v_spacer),
          _createVNode(_component_AdminAccommodationInquiryFormDialog, { onInquiryCreated: _ctx.handleInquiryCreated }, null, 8, ["onInquiryCreated"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_data_table, {
        headers: _ctx.headers,
        items: _ctx.filteredItems,
        "sort-by": [{ key: 'lastModification', order: 'desc' }],
        search: _ctx.normalizedSearch
      }, {
        [`item.publicReference`]: _withCtx(({ item }) => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.formatPublicReference(item.publicReference)), 1)
        ]),
        [`item.id`]: _withCtx(({ item }) => [
          _createVNode(_component_v_chip, {
            color: "blue",
            text: "Részletek",
            onClick: () => _ctx.handleViewClick(item.id)
          }, null, 8, ["onClick"])
        ]),
        [`item.status`]: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.inquiryStatusLabel(item.status)), 1)
        ]),
        _: 2
      }, 1032, ["headers", "items", "search"])
    ]),
    _: 1
  }))
}